import { type BreadcrumbListSchema } from './types'

interface BreadcrumbPage {
  title?: string
  url?: string
}

export const getBreadcrumbListSchema = (pages: BreadcrumbPage[]) => {
  const breadcrumbListSchema: BreadcrumbListSchema = {
    '@type': 'BreadcrumbList',
    itemListElement: pages.map((page, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: page.title,
      item: page.url,
    })),
  }

  return JSON.stringify(breadcrumbListSchema)
}
